import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const sendContactMessage = async (contactData: FormData) => {
  try {
    const response = await axios.post(`${API_URL}/contact`, contactData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error(
      "Erreur lors de l'envoi du message de contact :",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.error || "Erreur lors de l'envoi du message de contact."
    );
  }
};

